import { Duration } from "luxon";
import { PeriodISO } from "shared-ts-types";
import { BurnEventType } from "./BurnEventType";
import { _throw, IllegalStateError } from "shared-ts-utils-core";

export interface BurnEventDto {
  duration: PeriodISO;
  eventType: BurnEventType;
}

export class BurnEvent {
  readonly duration: Duration;
  readonly eventType: BurnEventType;

  constructor(args: BurnEventDto) {
    this.duration = Duration.fromISO(args.duration);
    this.eventType = args.eventType;
  }

  toDto(): BurnEventDto {
    return {
      duration:
        this.duration.toISO() ??
        _throw(new IllegalStateError("duration is invalid")),
      eventType: this.eventType,
    };
  }
}
